import { render, staticRenderFns } from "./removeReporter.vue?vue&type=template&id=0f25c2a8"
import script from "./removeReporter.vue?vue&type=script&lang=ts"
export * from "./removeReporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports